<template lang="html">

    <div class="academico-el row-start">

        <div class="left" v-if="!!data.Aniofin || !!data.anioinicio || data.cursoMasAlto">
          <h3 class="duracion" v-if="!!data.Aniofin || !!data.anioinicio">{{data.anioinicio}} <template v-if="!!data.Aniofin">-</template> {{data.Aniofin}}</h3>
          <h3 class="duracion" v-if="!!data.cursoMasAlto">Curso {{data.cursoMasAlto}}º</h3>
        </div>

        <div class="right">
          <h2 class="puesto">
            {{data.titulacion}}
          </h2>
          <h3 v-if="!!data.centro" class="centro">{{data.centro}}</h3>
          <p v-if="!!data.Nota" class="dato"><strong>Nota:</strong> {{data.Nota}}</p>
          <p v-if="!!data.Aniofin" class="dato"><strong>Año de promoción:</strong> {{data.Aniofin}}</p>
        </div>

      </div>


</template>

<script lang="js">
    export default {
        name: 'academico-el',
        props : ['data']
    }
</script>


// WEBPACK FOOTER //
// src/components/parts/academico-el.vue